import React from 'react';
import { Text, View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { updatePatientFromCase, setEditingPatient, resetState } from '../patient/actions';

import {
  getEditingPatient,
  getEditingPatientCurrentImmunizations,
  getEditingPatientRequiredImmunizations,
  getEditingPatientDeploymentInfo,
} from '../patient/selector';
import { IMMUNIZATION_CHECKLIST } from '../../constants/permissions';
import { editingCasePermissions } from '../../helpers/permissions';

import { getEditingCase } from '../cases/selector';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import {
  OPComponent,
  Container,
  NavBar,
  I18n,
  Utils,
  Navigation,
  SimpleHeader,
  CheckButtonList,
  DateUtils,
  Alert,
} from '../components';

import SelectedAirman from './selected_airman';

class Immunizations extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: !props.editingCase ? 'No case selected' : null,
      allImmunes: null,
    };
  }

  prepImmunizations = () => {
    const props = this.props;
    if (!props.editingCase) return [];

    const otherVaccines = this.props.allVaccines.filter(
      (vaccine) => !this.props.requiredVaccines.includes(vaccine)
    );
    const otherImmunizations = otherVaccines.map((vName) => {
      return {
        label: vName,
        id: vName,
        checked: !!props.currentVaccines[vName],
        editable: !props.currentVaccines[vName],
      };
    });

    const requiredImmunizations = this.props.requiredVaccines.map((vName) => {
      return {
        label: vName,
        id: vName,
        checked: !!props.currentVaccines[vName],
        editable: !props.currentVaccines[vName],
      };
    });

    return { otherImmunizations, requiredImmunizations };
  };

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Airforce', 'Immunizations Checklist');

    const editable = this.props.canEditEditingCasePatientImmunizations;

    Navigation.setButtons(
      {
        rightButtons: editable ? [NavBar.buttons.save] : [],
        leftButtons: editable ? [NavBar.buttons.cancel] : [NavBar.buttons.done],
      },
      this.props.componentId
    );

    Navigation.registerForButtonEvents(this);

    this.props.actions.setEditingPatient(this.props.editingCase.patientId);
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    this.props.actions.resetState();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.editingPatient !== prevProps.editingPatient) {
      const { otherImmunizations, requiredImmunizations } = this.prepImmunizations();
      this.setState({
        otherImmunizations,
        requiredImmunizations,
        allImmunes: [
          {
            label: I18n.t('airforce.allImmunesRegistered'),
            id: 'allImmunes',
            checked: this.props.deploymentInfo?.ready?.immunizations,
            editable: true,
          },
        ],
      });
    }

    if (this.props.status === SUCCESS && prevProps.status !== SUCCESS) {
      this.setState({
        showSuccess: true,
      });
      Navigation.setButtons(
        {
          rightButtons: [NavBar.buttons.save],
          leftButtons: [NavBar.buttons.done],
        },
        this.props.componentId
      );
    }

    if (this.state.showSuccess === true && prevState.showSuccess !== true) {
      setTimeout(() => {
        // Navigation.dismissModal(this.props.componentId);
        this.setState({ showSuccess: false });
      }, 500);
    }

    const errorMessage = this.props.errorMessage;
    if (errorMessage && errorMessage.message !== this.state.errorMessage) {
      this.setState({ errorMessage: errorMessage.message });
    }
  }

  handleRequiredImmunizationSelection = (requiredImmunizations) => {
    this.setState({ requiredImmunizations });
  };

  handleOtherImmunizationSelection = (otherImmunizations) => {
    this.setState({ otherImmunizations });
  };

  handleAllImmunesSelection = (allImmunes) => {
    this.setState({ allImmunes });
  };

  _save = () => {
    const props = this.props;
    const c = props.editingCase;
    const patient = props.editingPatient;

    const adminDate = new Date();

    const selectedImmunes = this.state.requiredImmunizations
      .concat(this.state.otherImmunizations)
      .filter((i) => i.checked);
    const allImmunesAdministered = !!this.state.allImmunes.filter((i) => i.checked).length;

    const immunizations = selectedImmunes.reduce((vals, item) => {
      vals[item.id] = {
        name: item.id,
        date: adminDate.toISOString(),
        adminsteredBy: this.props.userId,
      };
      return vals;
    }, {});

    let patientObj = {
      fullName: patient.fullName,
      email: patient.email,
      phone: patient.phone,
      extraData: {
        ...patient.extraData,
        deployment: {
          ...(patient.extraData?.deployment ?? {}),
          ready: {
            ...(patient.extraData?.deployment?.ready ?? {}),
            immunizations: allImmunesAdministered ? adminDate.toISOString() : null,
          },
        },
        immunizations: {
          ...immunizations,
          ...(patient.extraData?.immunizations ?? {}),
        },
      },
    };
    this.props.actions.updatePatientFromCase({ caseId: c.caseId, patient: patientObj });
  };

  onSave = () => {
    Alert.alert(I18n.ac('reviewChanges'), I18n.t('areYouSureYouWantToSave'), [
      {
        text: I18n.c1('cancel'),
      },
      {
        text: I18n.c1('save'),
        onPress: this._save,
      },
    ]);
  };

  renderSelectedCase = () => {
    const c = this.props.editingCase;
    const patient = this.props.editingPatient;
    if (!c || !patient) return null;

    return <SelectedAirman case={c} patient={patient} />;
  };

  _renderRightViewDate(completed, checked, date) {
    if (completed) {
      return (
        <View style={styles.selectedRightViewContainer}>
          <Text style={styles.selectedRightValueText}>
            {DateUtils.formatDateStringNumeric(date, null, { padDigits: true })}
          </Text>
        </View>
      );
    } else if (checked) {
      return (
        <View style={styles.unSelectedRightViewContainer}>
          <Text style={styles.unSelectedRightValueText}>
            {DateUtils.formatDateStringNumeric(date, null, {
              padDigits: true,
            })}
          </Text>
        </View>
      );
    } else {
      return (
        <View style={styles.unSelectedRightViewContainer}>
          <Text style={styles.unSelectedRightValueText}>{I18n.ac('completed')}?</Text>
        </View>
      );
    }
  }

  renderRightView = (vaccineName, checked) => {
    const currentImmunizations = this.props.currentVaccines;

    const currentImmune = currentImmunizations[vaccineName];
    if (currentImmune) {
      return this._renderRightViewDate(true, true, new Date(currentImmune.date));
    } else if (checked) {
      return this._renderRightViewDate(false, true, new Date());
    } else {
      return this._renderRightViewDate(false, false, null);
    }
  };

  renderAllImmunesRightView = (label, checked) => {
    const deploymentInfo = this.props.deploymentInfo;
    if (deploymentInfo?.ready?.immunizations) {
      return this._renderRightViewDate(true, true, new Date(deploymentInfo?.ready?.immunizations));
    } else if (checked) {
      return this._renderRightViewDate(false, true, new Date());
    } else {
      return this._renderRightViewDate(false, false, null);
    }
  };

  renderRequiredImmunizations = () => {
    if (!this.props.editingCase) return null;
    if (!this.props.deploymentInfo) return null;
    if (!this.state.requiredImmunizations?.length) return null;

    return (
      <View style={styles.listContainer}>
        <SimpleHeader label={I18n.t('airforce.requiredImmunizations')} />
        <CheckButtonList
          items={this.state.requiredImmunizations}
          multi={true}
          scrollable={false}
          onValuesChanged={this.handleRequiredImmunizationSelection}
          renderRightView={this.renderRightView}
        />
      </View>
    );
  };

  renderOtherImmunizations() {
    if (!this.props.editingCase) return null;
    if (!this.state.otherImmunizations?.length) return null;

    return (
      <View style={styles.listContainer}>
        <SimpleHeader label={I18n.t('airforce.otherImmunizations')} />
        <CheckButtonList
          items={this.state.otherImmunizations}
          multi={true}
          scrollable={false}
          onValuesChanged={this.handleOtherImmunizationSelection}
          renderRightView={this.renderRightView}
        />
      </View>
    );
  }

  renderReadinessCheckbox() {
    if (!this.props.editingCase) return null;
    if (!this.props.deploymentInfo) return null;
    if (!this.state.allImmunes) return null;

    return (
      <View style={styles.listContainer}>
        <CheckButtonList
          items={this.state.allImmunes}
          multi={true}
          scrollable={false}
          onValuesChanged={this.handleAllImmunesSelection}
          renderRightView={this.renderAllImmunesRightView}
        />
      </View>
    );
  }

  render() {
    if (!this.props.canViewEditingCasePatientImmunizations) return null;

    return (
      <Container
        style={styles.container}
        scrollView={true}
        innerContentStyle={!this.props.editingCase ? styles.innerContentStyle : null}
        renderActivityOverlay={this.props.status === REQUESTING}
        renderSuccessOverlay={this.state.showSuccess === true}
        errorMessage={this.state.errorMessage}
      >
        {this.renderSelectedCase()}
        {this.renderReadinessCheckbox()}
        {this.renderRequiredImmunizations()}
        {this.renderOtherImmunizations()}
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  container: __WEB__
    ? {
        ...THEME.containerAlt,
        // backgroundColor: 'pink'
        flexBasis: 'initial',
        flexGrow: 0,
      }
    : {
        ...THEME.containerAlt,
      },
  listContainer: __WEB__
    ? {
        flexBasis: 'initial',
        flexGrow: 0,
      }
    : {},
  innerContentStyle: {
    paddingTop: 60,
  },
  header: {
    flexDirection: 'row',
    height: 60,
    alignItems: 'center',
    backgroundColor: COLOR.accent,
    borderColor: '#e4e4e4',
    paddingHorizontal: 25,
    borderBottomWidth: 1,
    borderTopWidth: 1,
  },
  headerText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.small,
    color: COLOR.text,
  },
  nextButtonContainer: {
    paddingBottom: 25,
    paddingHorizontal: 35,
    paddingTop: 20,
    borderTopWidth: 1,
    borderColor: '#e4e4e4',
  },
  notDeployedText: {
    ...FONT.medium,
    fontSize: 16,
    color: COLOR.text,
    marginBottom: 7,
  },
  selectedRightViewContainer: {
    backgroundColor: COLOR.success,
    height: 30,
    justifyContent: 'center',
    paddingHorizontal: 15,
    borderRadius: 15,
  },
  selectedRightValueText: {
    ...FONT.bold,
    fontSize: 12,
    color: 'white',
  },
  unSelectedRightViewContainer: {
    height: 30,
    justifyContent: 'center',
    paddingHorizontal: 15,
    borderRadius: 15,
    borderWidth: 2,
    borderColor: COLOR.textLight,
  },
  unSelectedRightValueText: {
    ...FONT.bold,
    fontSize: 12,
    color: COLOR.textLight,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.patients.status,
    errorMessage: state.screens.patients.error,
    editingCase: getEditingCase(state),
    editingPatient: getEditingPatient(state),
    deploymentInfo: getEditingPatientDeploymentInfo(state),
    currentVaccines: getEditingPatientCurrentImmunizations(state),
    requiredVaccines: getEditingPatientRequiredImmunizations(state),
    allVaccines: state.entities.metaData.allVaccines,
    userId: state.entities.userProfile.userId,
    canEditEditingCasePatientImmunizations: editingCasePermissions(IMMUNIZATION_CHECKLIST).canEdit,
    canViewEditingCasePatientImmunizations: editingCasePermissions(IMMUNIZATION_CHECKLIST).canView,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        updatePatientFromCase,
        setEditingPatient,
        resetState,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Immunizations);
